import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import style from './style.vue';

@Component({
  components: {},
  mixins: [style],
})
export default class TextTitle extends Vue {
  @Prop({ default: () => {} })
    value: DisplayTextData;

  @Prop({ default: 1 })
    themeCode: number;

  render(h) {
    return (
      <div class="text" style={`margin:0 ${this.value.desc.margin}px;width: auto`}>
        {this.value.desc.title && (
          <p
            class={{
              'title-bold': this.value.desc.titleStyle.includes('bold'),
              'title-center': this.value.desc.titleStyle.includes('center'),
            }}
            style={`font-size: ${this.value.desc.titleSize / 2}px;color: ${this.value.desc.titleColor};`}>
            {this.value.desc.title}
          </p>
        )}
        {this.value.desc.content && (
          <p
            class={{
              'text-content': true,
              'content-bold': this.value.desc.contentStyle.includes('bold'),
              'content-center': this.value.desc.contentStyle.includes('center'),
            }}
            style={`font-size: ${this.value.desc.contentSize / 2}px;color: ${this.value.desc.contentColor};`}>
            {this.value.desc.content}
          </p>
        )}
      </div>
    );
  }
}
